import api from '../api';

export async function getSelectedAdditionalsGroupsByProduct(productId) {
  try {
    const { data } = await api.get(`/produto-adicionais/listar/${productId}`);

    return data;
  } catch (error) {
    console.log(error);

    return [];
  }
}
